import { useTranslation } from 'react-i18next';

import { TavoliMiei } from '@/components/gamehost/TavoliMiei';
import type { EtichetteTavoli, RisultatoTavoli } from '@/components/gamehost/TavoliMiei';
import { settemezzoApi } from '@/services/limuloSettemezzo';

/** La lettura dei miei tavoli di QUESTO gioco: una funzione di MODULO (stabile) che chiama la sua query RTK, come vuole il contratto di `TavoliMiei` (#747, A3). */
const usaTavoli = (): RisultatoTavoli => settemezzoApi.useGetMySettemezzoTablesQuery(undefined, { refetchOnMountOrArgChange: true });

/** La rotta del tavolo del sette e mezzo, dall'uuid minuscolo. */
const rottaTavolo = (tableId: string): string => `/settemezzo/tavolo/${tableId}`;

/**
 * «I MIEI TAVOLI / RIPRENDI» del sette e mezzo: la lobby COMUNE dei giochi del kit (`components/gamehost/TavoliMiei.tsx`, #747) coi parametri del sette e mezzo — la sua lettura (`settemezzo.table.mine.list`),
 * la rotta di «Riprendi» e i testi, GIA tradotti dal SUO catalogo (`settemezzo:hub.tavoli.*`): il componente comune non ha testi. Un solo formato (1 contro 1): il nome del tavolo e sempre «Sette e mezzo».
 */
export function TavoliMieiSettemezzo() {
  const { t } = useTranslation('settemezzo');
  const etichette: EtichetteTavoli = {
    titolo: t('hub.tavoli.titolo'),
    vuoto: t('hub.tavoli.vuoto'),
    inCorso: t('hub.tavoli.inCorso'),
    inAttesa: t('hub.tavoli.inAttesa'),
    riprendi: t('hub.tavoli.riprendi'),
    riprova: t('hub.tavoli.riprova'),
    guasto: { 'non-disponibile': t('hub.tavoli.guasto.non-disponibile'), rete: t('hub.tavoli.guasto.rete'), errore: t('hub.tavoli.guasto.errore') },
    nomeTavolo: () => t('titolo'),
  };
  return <TavoliMiei useTavoli={usaTavoli} rottaTavolo={rottaTavolo} etichette={etichette} />;
}
